import { AssignmentResponse } from '@/types';
import { WorkflowButton } from './WorkflowButton';
import { useAtomValue, useSetAtom } from 'jotai';
import {
  assignmentConversationsAtom,
  conversationsLoadingAtom,
  fetchAssignmentConversationsActionAtom,
} from '@/stores';
import { FileAudio } from 'lucide-react';
import { ConversationsList } from '../conversations';
import { useEffect } from 'react';

type TranscriptsBlockProps = {
  assignment: AssignmentResponse;
  isDetailsPage?: boolean;
};

export const TranscriptsBlock = ({
  assignment,
  isDetailsPage,
}: TranscriptsBlockProps) => {
  const fetchAssignmentConversations = useSetAtom(
    fetchAssignmentConversationsActionAtom
  );
  const conversationsLoading = useAtomValue(conversationsLoadingAtom);
  const conversations =
    useAtomValue(assignmentConversationsAtom)[assignment.id] || [];

  const handleFetchConversations = async () => {
    await fetchAssignmentConversations(assignment.id);
  };

  useEffect(() => {
    if (conversations.length === 0) {
      handleFetchConversations();
    }
  }, [conversations.length]);

  if (!assignment.personaId && conversations.length === 0) {
    return null;
  }

  return (
    <div>
      <WorkflowButton
        disabled={conversationsLoading}
        className='w-full'
        onClick={handleFetchConversations}
        isContentGenerated={conversations.length > 0}
        Icon={FileAudio}
        title={conversations.length > 0 ? 'Transcripts' : 'Check Conversations'}
      />

      {isDetailsPage && <ConversationsList conversations={conversations} />}
    </div>
  );
};
